const everadCampaigns = [];

const rocketCampaigns = [{
	id: 4,
	title: 'Dashboard main banner (NEW)',
	width: 1170,
	height: 110
}, {
	id: 1,
	title: 'Dashboard main banner (OLD)',
	width: 740,
	height: 442
}, {
	id: 2,
	title: 'Dashboard side banner 1 (OLD)',
	width: 280,
	height: 310
}, {
	id: 3,
	title: 'Dashboard side banner 2 (OLD)',
	width: 280,
	height: 310
}];

const campaigns = process.env.CPA_ENV === 'rocket'
	? rocketCampaigns
	: everadCampaigns;

const locale = {
	ru: campaigns,
	en: campaigns,
	uk: campaigns,
	de: campaigns,
	vi: campaigns,
	th: campaigns
};

module.exports = {
	enum: campaigns,
	locale
};


// WEBPACK FOOTER //
// ./enums/banner-campaigns.js